const styles = {
  popUp: {
    position: "absolute",
    top: "45px",
    transform: "translate(-50%, -50%)",
    maxWidth: 900,
    maxHeight: 700,
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "20px",
  },

  container: {
    maxHeight: 420,
    overflow: "auto",
  },
  avatar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    height: 40,
    width: 40,
    borderRadius: "50%",
  },
  listItem: {
    display: "flex",
    gap: 14,
    paddingBottom: 2,
  },
  reverseItem: {
    flexDirection: "row-reverse",
  },
  remarkText: {
    backgroundColor: "#E9E9E9",
    padding: "0px 10px 0px 10px",
    borderRadius: "10px 10px 10px 0px",
    height: "34px",
    width: "515px",
    fontSize: "12px",
    minWidth: "60px",
  },
  reverseRemarkText: {
    backgroundColor: "#D6F0FF",
    borderRadius: "10px 10px 0px 10px",
  },
  time: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "18px",
  },
  reverseTime: {
    justifyContent: "flex-start",
  },
};

export default styles;
